export default "__VITE_ASSET__C8Y47Q1W__"